import {GroupBalance, GroupBalanceCreate, GroupBalanceUpdate} from "./@types/GroupBalance";
export class GroupBalanceRepository {
    private httpService: IHttpService;
    private baseUrl: string;

    constructor(httpService: IHttpService) {
        this.httpService = httpService;
        this.baseUrl = '/group_balances';
    }
    async getAll(): Promise<GroupBalance[]>{
        const response = await this.httpService.get<TKResponse<GroupBalance[]>>(this.baseUrl);
        return response.data.sort((a, b) => ((a as any).name ?? '').localeCompare((b as any).name ?? ''));
    }
    async getOne(id: number): Promise<GroupBalance> {
        const response = await this.httpService.get<TKResponse<GroupBalance>>(`${this.baseUrl}/${id}`);
        return response.data;
    }
    async create(data: GroupBalanceCreate): Promise<GroupBalance> {
        const response = await this.httpService.post<TKResponse<GroupBalance>, GroupBalanceCreate>(this.baseUrl, { data });
        return response.data;
    }
    async update(id: number, data: GroupBalanceUpdate): Promise<GroupBalance> {
        const response = await this.httpService.patch<TKResponse<GroupBalance>, GroupBalanceUpdate>(`${this.baseUrl}/${id}`, { data });
        return response.data;
    }
    async delete(id: number): Promise<void> {
        return await this.httpService.delete(`${this.baseUrl}/${id}`);
    }
}

